module.exports = __webpack_public_path__ + "static/img/UOOYAA_geray_mena_vf_09.4ce140c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue13/DayAfterDay/UOOYAA_geray_mena_vf_09.jpg
// module id = +L0C
// module chunks = 7